export default __webpack_public_path__ + "static/media/lalamove_car.b0b2667a.png";